import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findIndex, } from 'lodash';
import OutsideNotifier from '../../OutsideNotifier';
import { updateCurrentActiveFixture } from './../../actions/ManageTeamActions';
import common from '../../common';

class Fixture extends Component {
    componentWillReceiveProps(nextProps) {
        if (this.props.currentActiveFixture !== nextProps.currentActiveFixture) {
            this.setState({ currentActiveFixture: nextProps.currentActiveFixture });
        }
    }

    setInitialState = () => {
        this.setState({
            isDDOpen: false,
            currentActiveFixture: this.props.userSpecificFixtures ? this.props.userSpecificFixtures[this.props.userSpecificFixtures.length - 1] : 0,
        });
    };

    componentWillMount() {
        this.setInitialState();
    }

    componentWillUnmount() {
        this.setInitialState();
    }

    onDDTap = () => {
        this.setState(prevState => ({
            isDDOpen: !prevState.isDDOpen,
        }));
    };
    onPreviousTap = () => {
        let { currentActiveFixture } = this.props;
        this.setState({ currentActiveFixture: --currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onNextTap = () => {
        let { currentActiveFixture } = this.props;
        this.setState({ currentActiveFixture: ++currentActiveFixture });
        this.getRespectiveData(currentActiveFixture);
    };
    onSelect = (currentActiveFixture) => {
        if (currentActiveFixture !== this.props.currentActiveFixture) {
            this.setState({ currentActiveFixture, isDDOpen: !this.state.isDDOpen });
            this.getRespectiveData(currentActiveFixture);
        } else {
            this.setState({ isDDOpen: !this.state.isDDOpen });
        }
    };
    getRespectiveData = (currentActiveFixture) => {
        this.props.updateCurrentActiveFixture(currentActiveFixture);
    };

    render() {
        const { isFixtureDisabled, userSpecificFixtures, currentActiveFixture, trans } = this.props;
        if (userSpecificFixtures.length === 0) return null;
        const matchDayTrans = trans['matchday'];
        const selectedMatchDay = userSpecificFixtures[currentActiveFixture];
        const selectedGDID = selectedMatchDay['GDID'];
        // // const selectedLabel = matchDayTrans + ' ' + selectedGDID;
        const selectedLabel = trans['rd' + selectedGDID];
        const currIndex = findIndex(userSpecificFixtures, { GDID: selectedGDID });
        const isFirst = currIndex === 0;
        const isLast = currIndex === (userSpecificFixtures.length - 1);
        const prevBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_right': true,
            'si-disabled': isFirst
        });
        const nextBtnClasses = common.makeClasses({
            'si-arrows': true,
            'icon-ucl-arrow_left': true,
            'si-disabled': isLast
        });
        const fixtureClasses = common.makeClasses({
            'si-selectbox': true,
            'si-disabled': isFixtureDisabled
        });
        return <div className={fixtureClasses}>
            <div className="si-dropdown-btn">
                <i className={prevBtnClasses} onClick={() => this.onPreviousTap()} />
                <span onClick={() => this.onDDTap()}>{selectedLabel}</span>
                <i className={nextBtnClasses} onClick={() => this.onNextTap()} />
            </div>
            {this.state.isDDOpen ? <OutsideNotifier handler={() => this.onDDTap()}>
                <ul className="si-dropdown-options">
                    {userSpecificFixtures.map((el, index) => {
                        const currGDID = el['GDID'];
                        // const selectedLabel = matchDayTrans + ' ' + currGDID;
                        const selectedLabel = trans['rd' + currGDID];
                        const isSelected = selectedGDID === currGDID ? 'si-selected' : '';
                        return <li key={currGDID} className={isSelected} onClick={() => this.onSelect(index)}>
                            <span>{selectedLabel}</span></li>
                    })}
                </ul>
            </OutsideNotifier> : null}
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        userSpecificFixtures: state.formationData.userSpecificFixtures,
        currentActiveFixture: state.formationData.currentActiveFixture,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateCurrentActiveFixture: (index) => dispatch(updateCurrentActiveFixture(index))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Fixture);


// WEBPACK FOOTER //
// ./src/components/manage-team/Fixture.js